<template>
    <div class="vets">
        <div class="vets__sidebar">
            <div class="vets__filters">
                <div class="vets__filtersgroup filter">
                    <h5 class="filter__name r-title">ФИО врача</h5>
                    <div class="filter__items">
                        <div class="filter__item">
                            <el-input v-model="doctorName"
                                      clearable
                                      placeholder="Искать по ФИО"
                                      size="mini"
                                      @change="getDoctors()"/>
                        </div>
                    </div>
                </div>
                <template v-for="(item, key) in filter">
                    <div class="vets__filtersgroup filter">
                        <h5 class="filter__name r-title">{{ item.title }}</h5>
                        <div class="filter__items">
                            <div class="filter__item">
                                <label class="toggle">
                                    <input type="checkbox" :ref="'all' + key" class="toggle__input screen-reader" @click="checkAll(filter[key], $event)"
                                           :disabled="isLoaded">
                                    <span class="toggle__label">
                                    <span class="toggle__text">
                                        Показать всех
                                    </span>
                                </span>
                                </label>
                            </div>
                            <div class="filter__item" v-for="element in item.elements">
                                <label class="toggle">
                                    <input class="toggle__input screen-reader" type="checkbox" @click="uncheckSelectAll(key)" v-model="element.checked"
                                           :disabled="isLoaded">
                                    <span class="toggle__label">
                                    <span class="toggle__text">
                                        {{ element.title }}
                                    </span>
                                </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </template>
<!--                <div class="vets__filtersgroup filter">-->
<!--                    <h5 class="filter__name r-title">Специальности</h5>-->
<!--                    <div class="filter__items">-->
<!--                        <div class="filter__item vets__specialties">-->
<!--                            <el-select-->
<!--                                multiple-->
<!--                                filterable-->
<!--                                class="form__select"-->
<!--                                v-model="selectSpecialties"-->
<!--                                @change="getDoctors()"-->
<!--                                popper-class="vets__specialties"-->
<!--                                placeholder="Введите специальность"-->
<!--                                no-match-text="Не найдено">-->
<!--                                <el-option-->
<!--                                    v-for="item in specialties"-->
<!--                                    :key="item.id"-->
<!--                                    :label="item.speciality"-->
<!--                                    :value="item.id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
        <div class="vets__list">
            <template v-for="doctor in doctors.data">
                <div class="v-card" v-if="doctor.user && doctor.user.active" @click="saveFilter()">
                    <div class="v-card__intro">
                        <img :src="doctor.user.avatar" class="v-card__photo avatar" :alt="doctor.user.title">
                        <a :href="'covid19/' + doctor.slug + '/' + typeGetParam + typeGetParam" class="v-card__name r-link">{{ doctor.user.title }}</a>
                        <div class="v-card__caption">
                            <template v-for="doctorSpec in doctor.doctor_specialties">
                                <span>{{ doctorSpec.speciality }}</span><span>, </span>
                            </template>
                            <span>{{ doctor.clinic_id ? doctor.clinic.user.name : 'Частный врач' }}</span>
                        </div>
                        <div class="v-card__bottom" v-if="doctor.appointments_count > 0 && (!authUserType || authUserType === 'patient')">
                            <a :href="'covid19/' + doctor.slug + '/' + typeGetParam" class="r-link button">Записаться</a>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div>
        </div>
        <div class="vets__pagination pagination-block">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="doctors.total"
                :page-size="doctors.per_page"
                :current-page="doctors.current_page"
                @current-change="getDoctors($event)">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import api from '../../../../admin/api/api';
    import '../../../../../ui/components/vue-pagination.css';

    export default {
        data: () => ({
            selectSpecialties: [],
            doctors: [],
            filter: [],
            specialties: [],
            countOnPage: 3,
            currentPage: 1,
            total: 1,
            doctorName: null,
            allDoctors: [],
            authUserType: window.laravel.user ? window.laravel.user.type : null,
            roles: window.laravel.roles,
            isLoaded: false,
            domainTelemed: window.laravel.domainTelemed,
            domainTelemedDoctors: window.laravel.domainTelemedDoctors,
            onlineTypeId: window.laravel.onlineTypeId,
            typeGetParam: null,
            testRole: window.laravel.testRole,
            city: window.laravel.city,
        }),
        watch: {
			checked(value) {
                this.typeGetParam = value.appointmentTypes ? '?appointment-type=' + value.appointmentTypes.toString() : '';
			    this.isLoaded = true;
                this.getDoctors();
                sessionStorage.setItem('filterCheckbox', JSON.stringify(this.filter));
            },
        },
        computed: {
            checked() {
            	const checked = {};

				for (let key in this.filter) {
					this.filter[key].elements.forEach((element) => {
						if (element.checked) {
							if (!checked[key])
								checked[key] = [];

							checked[key].push(element.id);
						}
					});
				}

            	return checked;
            },
        },
        methods: {
            getDoctors(page) {

                let authUserRoleTest = false;

                if(this.roles){
                    authUserRoleTest = !!this.roles.find(item => item.code === this.testRole);
                }

                let params = {
                    page,
                    doctorSpecialties: this.selectSpecialties,
                    doctorName: this.doctorName,
                    appointmentTypes: this.filter['appointmentTypes']['elements'],
                    authUserRoleTest: authUserRoleTest,
                    city: this.city,
                    // doctorTypes: this.filter['doctorTypes']['elements']
                };

				api.post('/api/doctor-covid', params)
					.then((response) => {
                        this.doctors = response.data;
					}).catch((error) => {
                        this.$appNotify.error(error.response.data);
                    }).finally(() => {
                        this.isLoaded = false;
                    });
            },
            generateFilter() {
				return {
                    appointmentTypes: {
                        title: 'Тип записи',
                        elements: window.laravel.appointmentTypes,
                    },
                    // doctorTypes: {
					// 	title: 'Тип врача',
					// 	elements: window.laravel.doctorTypes,
					// }
                };
            },
            checkAll(item, event) {
                item.elements.forEach((element) => {
                    this.$set(element, 'checked', event.target.checked);
                });
            },
            uncheckSelectAll(key) {
                this.$refs['all' + key][0].checked = false;
            },
            pageCount: function () {
                return Math.ceil(this.doctors.length / this.countOnPage);
            },
            saveFilter() {
                sessionStorage.setItem('saveFilterDoctors', true);
            }
        },
        created() {
			this.filter = this.generateFilter();

			let filterCheckbox = JSON.parse(sessionStorage.getItem('filterCheckbox'));
            let saveFilter = JSON.parse(sessionStorage.getItem('saveFilterDoctors'));
            sessionStorage.setItem('saveFilterDoctors', false);

            // if (saveFilter) {
            //     this.filter['doctorTypes']['elements'].forEach((element, key) => {
            //         if (filterCheckbox && filterCheckbox['doctorTypes'] && filterCheckbox['doctorTypes']['elements'][key]['checked']) {
            //             this.$set(element, 'checked', true);
            //         }
            //     });
            // }

            this.filter['appointmentTypes']['elements'].forEach((element, key) => {
                if (filterCheckbox && filterCheckbox['appointmentTypes'] && filterCheckbox['appointmentTypes']['elements'][key]['checked'] && saveFilter){
                    this.$set(element, 'checked', true);
                } else if (element.id === this.onlineTypeId && (document.domain === this.domainTelemed || document.domain === this.domainTelemedDoctors)) {
                    this.$set(element, 'checked', true);
                }
            });

            this.specialties = window.laravel.specialties;
        },
    }
</script>

<style>
    .margin-top {
        margin-top: 20px;
    }
    .doctor_list .el-select__input {
        max-width: 100% !important;
        margin: 0 10px !important;
    }
    .doctor_list .el-select__tags {
        max-width: 100% !important;
    }
    .doctor_list .el-input__inner{
        padding-right: 10px !important;
        padding-left: 10px !important;
        cursor: text !important;
    }
    .doctor_list .el-input__suffix {
        display: none;
    }
</style>
